(function(){
    "use strict";

    // Event delegation helper
    function delegateEvent(parent, selector, eventType, handler) {
        parent.addEventListener(eventType, function(e) {
            const target = e.target.closest(selector);
            if (target && parent.contains(target)) {
                handler.call(target, e);
            }
        });
    }

    // Helper functions
    const yotuwp = {
        data : {
            ready : false,
            players : {},
            videos : {},
            actions : {},
            filters : {}
        },

        init : function (){
            yotuwp.data.ready = true;
            clearInterval(window.yotu_check);

            document.addEventListener('DOMContentLoaded', function() {

                const ua = navigator.userAgent;
                const hash = window.location.hash;

                document.querySelectorAll('.yotu-playlist').forEach(function(elm, ind){

                    const player = elm.dataset.yotu;
                    const settings = yotuwp.helper.settings(elm);
                    let loaded_ids = [];
                    let loaded_page = [1];
                    const firstVideo = elm.querySelector('.yotu-videos li:first-child a');
                    const firstId = firstVideo ? firstVideo.dataset.videoid : null;

                    console.log(settings)
                    console.log(firstId)
                    console.log(typeof yotuwp.data.players[player])

                    if (settings.player['autoplay'] == 0) delete settings.player['autoplay'];

                    if (player !== 'modal' && firstId !== false && typeof yotuwp.data.players[player] === 'undefined') {

                        if (settings.player.loop) {
                            settings.player['playlist'] = firstId;
                        }

                        const player_setting = settings.player;
                        const delete_keys = ['scrolling', 'width', 'mode', 'playing', 'playing_description'];

                        delete_keys.forEach(function(key){
                            if(typeof player_setting[key] !== 'undefined') delete player_setting[key];
                        });

                        yotuwp.data.players[player] = new YT.Player('yotu-player-' + player, {
                            width: 1000,
                            height: 600,
                            playerVars: player_setting,
                            videoId: firstId,
                            events: {
                                'onStateChange': function (e){
                                    yotuwp.do_action('player_status', e);
                                }
                            }
                        });
                    }

                    //find thumbs
                    elm.querySelectorAll('.yotu-videos a.yotu-video').forEach(function(video, ind) {
                        const videoId = video.dataset.videoid;
                        const thumb = video.querySelector('img')?.getAttribute('src');
                        if(typeof yotuwp.data.videos[videoId] === 'undefined')
                            yotuwp.data.videos[videoId] = [];
                        yotuwp.data.videos[videoId].push(thumb);
                        loaded_ids.push(videoId);
                    });

                    elm.dataset.loaded = JSON.stringify(loaded_ids);
                    elm.dataset.loadedPage = JSON.stringify(loaded_page);
                    elm.dataset.lastToken = settings.next;
                });

                // Event delegation for pagination
                delegateEvent(document.body, '.yotu-pagination a', 'click', function(e) {
                    e.preventDefault();
                    const target = this;
                    const wrp = target.closest('.yotu-playlist');

                    if (target.classList.contains('yotu-active')) return;

                    target.classList.add('yotu-active');

                    yotuwp.list.load(
                        wrp,
                        yotuwp.list.update,
                        {
                            page : target.dataset.page,
                            current : parseInt(wrp.dataset.page || 1),
                            func : 'pagination'
                        }
                    );
                });

                // Event delegation for video clicks
                delegateEvent(document.body, '.yotu-videos a.yotu-video', 'click', yotuwp.list.events);

                yotuwp.add_action('player_status', yotuwp.player.status);
                yotuwp.add_action('player_status_modal', yotuwp.player.status);

                //hash url
                if (hash != '' && typeof yotuwp.data.videos[hash.replace('#','')] !== 'undefined') {
                    setTimeout(function(){
                        const hashLink = document.querySelector("a[href='"+hash+"']");
                        if(hashLink) hashLink.click();
                    }, 1000);
                }

            });
        },

        helper : {
            decode: function (str) {
                return JSON.parse(decodeURIComponent(window.atob(str)));
            },
            encode: function (obj) {
                return window.btoa(encodeURIComponent(JSON.stringify(obj)));
            },
            settings : function (elm) {
                return JSON.parse(decodeURIComponent(window.atob(elm.dataset.settings)));
            },
        },

        add_action : function (name, callback) {
            if (yotuwp.data.actions[name] === undefined)
                yotuwp.data.actions[name] = [];

            yotuwp.data.actions[name].push(callback);
        },

        do_action : function(name) {
            const params = Array.prototype.slice.call(arguments, 1);
            if (yotuwp.data.actions[name] !== undefined) {
                let res;
                yotuwp.data.actions[name].forEach(function(func) {
                    if (typeof func == 'function') {
                        try {
                            res = func.apply(null, params);
                        }catch(e){
                            console.warn('action '+name+':' + e.message);
                        }
                    }
                });
            }
        },

        apply_filter: function (name, val) {
            const params = Array.prototype.slice.call(arguments, 2, arguments.length);
            params.push(val);
            if (yotuwp.data.filters[name] !== undefined) {
                yotuwp.data.filters[name].forEach(function(func) {
                    if (typeof func == 'function') {
                        try {
                            val = func.apply(null, params);
                        }catch(e){
                            console.warn('action '+name+':' + e.message);
                        }
                    }
                });
            }
            return val;
        },

        add_filter: function (name, callback) {
            if (yotuwp.data.filters[name] === undefined)
                yotuwp.data.filters[name] = [];

            yotuwp.data.filters[name].push(callback);
        },

        l: function (ind) {
            return (yotujs.lang[ind]!== 'undefined')? yotujs.lang[ind] : '';
        },

        player : {

            data : {
            },
            current : {
                'player' : null,
                'video' : null,
                'list' : null
            },

            play : function (video, list) {

                const player = list.dataset.yotu;
                const settings = yotuwp.helper.settings(list);
                const loaded_ids = JSON.parse(list.dataset.loaded || '[]');

                if (
                    typeof yotuwp.data.players[player] !== 'undefined' ||
                    player == 'modal'
                ) {

                    if (player === 'modal') {
                        yotuwp.player.lightbox.open(
                            video,
                            settings,
                            list
                        );
                    }
                    else {

                        const playtimer = setInterval(function (){
                            if (typeof yotuwp.data.players[player]['loadVideoById'] == 'function') {
                                yotuwp.data.players[player].loadVideoById(video);
                                let pos = list.offsetTop - settings.player.scrolling;

                                if (settings.player.scrolling == 0) {
                                    //find center top
                                    const playerElm = document.getElementById('yotu-player-' + player);
                                    const pheight = playerElm ? playerElm.offsetHeight : 0;
                                    const wheight = window.innerHeight;

                                    pos = list.offsetTop - parseInt((wheight - pheight) / 2);
                                }

                                window.scrollTo({
                                    top: pos,
                                    behavior: 'smooth'
                                });
                                clearInterval(playtimer);
                            }
                        }, 10);

                    }

                    this.current = {
                        'player' : player,
                        'video' : video,
                        'list' : list
                    };

                    yotuwp.do_action('after_play_video', loaded_ids, video, player);

                    this.info();
                    this.pause();
                }
            },

            pause : function () {
                for (let p in yotuwp.data.players) {
                    if (
                        p !== yotuwp.player.current.player &&
                        typeof yotuwp.data.players[p] !== 'undefined' &&
                        typeof yotuwp.data.players[p]['pauseVideo'] == 'function'
                    )
                        yotuwp.data.players[p].pauseVideo();
                }
            },

            gen_thumbs : {},

            info : function () {
                const playerElm = document.getElementById('yotu-player-' + yotuwp.player.current.player);
                if(!playerElm) return;

                const wrp = playerElm.closest('.yotu-wrapper-player');
                if(!wrp) return;

                const playingElm = wrp.querySelector('.yotu-playing');
                const playingDescElm = wrp.querySelector('.yotu-playing-description');

                if(playingElm) playingElm.innerHTML = yotuwp.data.videos[this.current.video][0];
                if(playingDescElm) playingDescElm.innerHTML = yotuwp.data.videos[this.current.video][1];
            },

            lightbox : {

                loaded : false,

                render : function (){
                    const html_a = ['<div class="yotu-lightbox">',
                        '<div class="yotu-lightbox-body">',
                        '<div class="yotu-lightbox-content yotu-wrapper-player">',
                        '<div class="yotu-playing"></div>',
                        '<div class="yotu-player"><div id="yotu-player-modal"></div></div>',
                        '<div class="yotu-playing-status"></div>',
                        '</div>',
                        '</div>',
                        '<div class="yotu-thumbnails-wrp" data-yotu="modal"><div id="yotu-thumbnails" class="yotu-thumbnails"></div></div>',
                        '<a href="#" class="yotu-lightbox-close" title=""><span class="yotuicon-close"></span></a>',
                        '<div class="yotu-copyright"><a href="http://bit.ly/yotuwp-popup" rel="nofollow" target="_blank">Power by YoutuWP</a></div>',
                        '<div class="yotu-lightbox-overlay"></div>',
                        '</div>'];

                    const filteredHtml = yotuwp.apply_filter('next_prev', html_a);

                    const tempDiv = document.createElement('div');
                    tempDiv.innerHTML = filteredHtml.join('');
                    const elm = tempDiv.firstChild;
                    document.body.appendChild(elm);

                    // Event handlers
                    elm.querySelector('.yotu-lightbox-overlay')?.addEventListener('click', yotuwp.player.lightbox.close);
                    elm.querySelector('.yotu-lightbox-close')?.addEventListener('click', yotuwp.player.lightbox.close);

                    delegateEvent(elm, '.yotu-lightbox-func', 'click', function(e){
                        e.preventDefault();
                        yotuwp.do_action('lightbox_actions', this);
                    });

                    this.loaded = true;
                },

                open : function (video, settings, list){
                    if (!this.loaded) {
                        this.render();
                    }

                    if (yotuwp.player.current.list !== list) {

                        settings.player['enablejsapi'] = 1;
                        const player_setting = settings.player;
                        const delete_keys = ['scrolling', 'width', 'mode', 'playing', 'playing_description'];

                        delete_keys.forEach(function(key){
                            if(typeof player_setting[key] !== 'undefined') delete player_setting[key];
                        });

                        player_setting['origin'] = document.location.protocol+"//"+document.location.hostname;
                        player_setting['enablejsapi'] = 1;
                        player_setting['iv_load_policy'] = 3;
                        player_setting['widgetid'] = 3;

                        yotuwp.player.current.list = list;

                        const modalPlayer = document.getElementById('yotu-player-modal');
                        if(modalPlayer) {
                            modalPlayer.replaceWith(document.createElement('div'));
                            document.querySelector('#yotu-player-modal').id = 'yotu-player-modal';
                        }

                        yotuwp.data.players['modal'] = new YT.Player('yotu-player-modal', {
                            width: 1000,
                            height: 600,
                            playerVars: player_setting,
                            videoId: video,
                            events: {
                                'onStateChange': function (e){
                                    yotuwp.do_action('player_status_modal', e);
                                }
                            }
                        });
                    } else {
                        yotuwp.data.players['modal'].loadVideoById(video);
                    }

                    const lightbox = document.querySelector('.yotu-lightbox');

                    if (settings.player.playing) {
                        lightbox.classList.add('yotu-show-title');
                    }

                    if (settings.player.thumbnails && settings.pagination) {
                        const loaded_ids = JSON.parse(list.dataset.loaded || '[]');
                        const thumbs = document.getElementById('yotu-thumbnails');
                        const loaded_page = JSON.parse(list.dataset.loadedPage || '[1]');
                        const current = Math.max.apply(Math, loaded_page);
                        const total = parseInt(list.dataset.total);

                        const thumbsWrp = lightbox.querySelector('.yotu-thumbnails');
                        thumbsWrp.classList.remove('yotu-thumb-169');
                        if(list.classList.contains('yotu-thumb-169')) {
                            thumbsWrp.classList.add('yotu-thumb-169');
                        }

                        if (current < total && settings.pagination == 'on') {
                            const load_more = document.createElement('a');
                            load_more.href = '#';
                            load_more.className = 'yotu-lightbox-more';
                            load_more.innerHTML = '<span class="yotuicon-more"></span>';

                            load_more.addEventListener('click', function(e){
                                e.preventDefault();
                                const loaded_page = JSON.parse(list.dataset.loadedPage || '[1]');
                                const current = Math.max.apply(Math, loaded_page);

                                if (load_more.classList.contains('yotu-loading')) return;

                                load_more.classList.add('yotu-loading');

                                if (current + 1 == total)
                                    load_more.remove();

                                yotuwp.list.load(
                                    list,
                                    function (wrp, res, data){
                                        const loaded_page = JSON.parse(wrp.dataset.loadedPage || '[1]');
                                        const settings = yotuwp.helper.settings(yotuwp.player.current.list);

                                        load_more.classList.remove('yotu-loading');

                                        if (res.settings.next === '')
                                            load_more.remove();

                                        if (res.items.length > 0){
                                            res.items.forEach(function(item){
                                                const imgDiv = document.createElement('div');
                                                imgDiv.innerHTML = '<img data-videoid="'+item.videoId+'" src="'+item.thumb+'"/>';
                                                thumbs.appendChild(imgDiv);
                                            });

                                            delegateEvent(thumbs, 'img', 'click', yotuwp.player.lightbox.play_video);
                                        }
                                    },
                                    {
                                        page : 'next',
                                        current : current,
                                        func : 'load_thumb',
                                        next : list.dataset.lastToken
                                    }
                                );
                            });

                            document.querySelector('.yotu-thumbnails-wrp').appendChild(load_more);
                        }

                        loaded_ids.forEach(function(video){
                            const imgDiv = document.createElement('div');
                            imgDiv.innerHTML = '<img data-videoid="'+video+'" src="'+yotuwp.data.videos[video][2]+'"/>';
                            thumbs.appendChild(imgDiv);
                        });

                        yotuwp.do_action('after_play_video', loaded_ids, video, 'modal');

                        delegateEvent(thumbs, 'img', 'click', yotuwp.player.lightbox.play_video);
                    }

                    lightbox.style.display = 'block';
                },

                play_video : function (e){
                    e.preventDefault();
                    const video = e.target.dataset.videoid;
                    yotuwp.data.players['modal'].loadVideoById(video);
                    yotuwp.player.current.video = video;
                    yotuwp.player.info();
                },

                close : function (e){
                    e.preventDefault();

                    const thumbs = document.getElementById('yotu-thumbnails');
                    if(thumbs) thumbs.innerHTML = '';

                    const thumbsWrp = document.querySelector('.yotu-thumbnails-wrp');
                    if(thumbsWrp) thumbsWrp.classList.remove('yotu-active');

                    const lightbox = document.querySelector('.yotu-lightbox');
                    if(lightbox) {
                        lightbox.style.display = 'none';
                        lightbox.classList.remove('yotu-active', 'yotu-has-thumbs', 'yotu-has-loadmore', 'yotu-show-title');
                    }

                    if(
                        typeof yotuwp.data.players['modal'] !== 'undefined' &&
                        typeof yotuwp.data.players['modal']['stopVideo'] == 'function'
                    )
                        yotuwp.data.players['modal'].stopVideo();

                },
            },

            status : function (e){

                const status  = e.data;
                let wrp     = null;
                let player  = '';
                const playing = e.target.getVideoData();

                //parse element for getting wrapper tag
                Object.keys(e.target).forEach(function(k){
                    let prop = e.target[k];
                    if(prop.tagName == 'IFRAME') {
                        wrp = prop.closest('.yotu-playlist');
                    }
                });

                if(!wrp) return;
                player = wrp.dataset.yotu;

                if(typeof playing['video_id'] === 'undefined') return;

                if(
                    status === 1 &&
                    yotuwp.player.current.player !== 'modal'
                ){
                    yotuwp.player.current = {
                        'player': player,
                        'video' : playing.video_id,
                        'list'  : wrp
                    };
                }

                const settings = yotuwp.helper.settings(yotuwp.player.current.list);

                if(yotuwp.player.current.player === 'modal'){
                    wrp = e.target.a.closest('.yotu-lightbox');
                }

                if(
                    status === 0 &&
                    typeof settings.player['autonext'] !== 'undefined' &&
                    settings.player.autonext === 1
                ){

                    const videos    = yotuwp.player.current.list.querySelectorAll('[data-videoid]');
                    let found     = false;
                    let nextvideo = '';

                    for(let i = 0; i < videos.length; i++){
                        if(found){
                            nextvideo = videos[i].dataset.videoid;
                            break;
                        }

                        if(videos[i].dataset.videoid == yotuwp.player.current.video){
                            found = true;
                        }
                    }

                    if(nextvideo === ''){
                        nextvideo = videos[0].dataset.videoid;
                    }

                    if(yotuwp.player.current.player === 'modal'){
                        yotuwp.data.players['modal'].loadVideoById(nextvideo);
                        yotuwp.player.current.video = nextvideo;
                        yotuwp.player.info();
                    } else {
                        const nextVideoElm = yotuwp.player.current.list.querySelector('[data-videoid="'+nextvideo+'"]');
                        if(nextVideoElm) nextVideoElm.click();
                    }
                }
            }
        },

        list : {
            load : function (wrp, func, atts){

                const settings = yotuwp.helper.settings(wrp);
                const loaded_page = JSON.parse(wrp.dataset.loadedPage || '[1]');
                const loaded_ids = JSON.parse(wrp.dataset.loaded || '[]');
                const load_more = wrp.querySelector('.yotu-pagination a');
                let data = {};

                const error = function (code){
                    let text = '';
                    switch(code) {
                        case 403:
                            text = yotujs.lang[1];
                            break;
                        case 404:
                            text = yotujs.lang[3];
                            break;
                        case 500:
                            text = yotujs.lang[6];
                            break;
                        case 504:
                            text = yotujs.lang[5];
                            break;
                    }

                    if(text !== '') alert(text);

                    if(load_more) load_more.classList.remove('yotu-active');
                };

                delete settings['player'];
                delete settings['pagination'];
                delete settings['pagitype'];

                if(typeof atts.next !== 'undefined'){
                    settings['next'] = atts.next;
                }

                data = {
                    'page': atts.page,
                    'settings': yotuwp.helper.encode(settings),
                    'action': 'yotu_pagination',
                    'security': yotujs.security
                };

                fetch(yotujs.ajax_url + '?'+Math.random(), {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                    },
                    body: new URLSearchParams(data)
                })
                .then(response => {
                    if(response.status === 403) {
                        error(403);
                        throw new Error('Forbidden');
                    }
                    if(response.status === 404) {
                        error(404);
                        throw new Error('Not Found');
                    }
                    if(!response.ok) {
                        error(500);
                        throw new Error('Server Error');
                    }
                    return response.json();
                })
                .then(res => {
                    if (res.error) {
                        error(504);
                        return;
                    }

                    atts.current += (data.page == 'next' || data.page == 'more')? 1 : -1;

                    wrp.dataset.page = atts.current;

                    switch(atts.func) {
                        case 'pagination':
                            const currentElm = wrp.querySelector('.yotu-pagination-current');
                            if(currentElm) currentElm.innerHTML = atts.current;
                            if(load_more) load_more.classList.remove('yotu-active');
                            break;
                        case 'load_thumb':
                            break;
                    }

                    if (loaded_page.indexOf(atts.current) === -1) {

                        loaded_page.push(atts.current);

                        wrp.dataset.loadedPage = JSON.stringify(loaded_page);

                        if (res.settings.next !== "") {
                            wrp.dataset.lastToken = res.settings.next;
                        }
                    }

                    Object.keys(res.items).forEach(function(ind) {
                        if(loaded_ids.indexOf(res.items[ind].videoId) == -1)
                            loaded_ids.push(res.items[ind].videoId);

                        if(typeof yotuwp.data.videos[res.items[ind].videoId] === 'undefined'){
                            yotuwp.data.videos[res.items[ind].videoId] = [
                                res.items[ind].title,
                                res.items[ind].description,
                                res.items[ind].thumb
                            ];
                        }

                    });

                    wrp.dataset.loaded = JSON.stringify(loaded_ids);

                    if (typeof func === 'function') {
                        func(wrp, res, data);
                    }
                })
                .catch(err => {
                    console.error('AJAX Error:', err);
                });

            },

            events : function (e){
                e.preventDefault();
                const target = e.target;
                const videoElm = target.dataset.videoid ? target : target.closest('.yotu-video');

                yotuwp.player.play(
                    videoElm.dataset.videoid,
                    target.closest('.yotu-playlist')
                );
            },

            update : function (wrp, res, data){

                const settings = yotuwp.helper.settings(wrp);
                const current = parseInt(wrp.dataset.page || 1);
                const loaded_page = JSON.parse(wrp.dataset.loadedPage || '[1]');

                const tempDiv = document.createElement('div');
                tempDiv.innerHTML = res.html;
                const html = tempDiv.firstChild;

                const paginationLink = wrp.querySelector('.yotu-pagination a');
                if(paginationLink) paginationLink.blur();

                Object.keys(res.settings).forEach(function(key){
                    settings[key] = res.settings[key];
                });

                wrp.dataset.settings = yotuwp.helper.encode(settings);

                if(data.page !== 'more') {
                    const videosElm = wrp.querySelector('.yotu-videos');
                    if(videosElm) videosElm.replaceWith(html);
                } else {
                    const loadingElm = wrp.querySelector('.yt_loading');
                    if(loadingElm) loadingElm.remove();

                    if (['masonry', 'carousel'].indexOf(settings.template) > -1) {
                        yotuwp.do_action('loadmore-'+settings.template, wrp, html, settings);
                    } else {
                        const videosList = wrp.querySelector('.yotu-videos ul');
                        const htmlList = html.querySelector('ul');
                        if(videosList && htmlList) {
                            videosList.innerHTML += htmlList.innerHTML;
                        }
                    }

                    if (res.settings.next === "") {
                        const pagination = wrp.querySelector('.yotu-pagination');
                        if(pagination) pagination.classList.add('yotu-hide');
                    }
                }

                // Re-attach event handlers
                delegateEvent(wrp, '.yotu-videos a.yotu-video', 'click', yotuwp.list.events);

                const total = parseInt(wrp.dataset.total);
                if(current == total)
                    wrp.classList.remove('yotu-limit-min').add('yotu-limit-max');
                else if(current == 1)
                    wrp.classList.add('yotu-limit-min').remove('yotu-limit-max');
                else
                    wrp.classList.remove('yotu-limit-min', 'yotu-limit-max');
            }
        }
    };

    window.yotuwp = yotuwp;
})();

if (typeof window['YT'] === 'undefined')
{
    const tag = document.createElement('script');
    tag.src = "https://www.youtube.com/iframe_api";
    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
}

if(typeof window.onYouTubeIframeAPIReady == 'undefined'){
    window.onYouTubeIframeAPIReady = function () {
        yotuwp.init();
    };
} else if (typeof window.YT !== 'undefined'){
    yotuwp.init();
}

window.yotu_check = setInterval(function (){
    if (typeof window.YT !== 'undefined' && window.YT.loaded)
    {
        if(!yotuwp.ready) yotuwp.init();
    }
}, 10);
